export const description =
  'Ten Thousand Coffees is an enterprise social learning platform that connects employees across teams, lines of businesses, levels, and geographies to help them learn share and grow.';
export const keywords =
  'social learning platform, networking, mentoring, cross-team collaboration, silos, onboarding, learning and development, LMS, learning management software, employee engagement, enterprise software';
